/* ------------------------------------------------------------------------- */
/*  Simple countdown timer
/* ------------------------------------------------------------------------- */

class Countdown {

  constructor(countdownElement) {
    if (!countdownElement) {
      return;
    }

    this.countdownElement = countdownElement;

    const countDownEndedString = this.countdownElement.getAttribute('data-string-end') || 'Meni jo!';
    const countDownDateString = this.countdownElement.getAttribute('data-target-date');

    // Set the date we're counting down to
    this.countDownDate = new Date(countDownDateString).getTime();

    this.days = 0;
    this.daysHours = 0;
    this.hours = 0;
    this.minutes = 0;
    this.seconds = 0;

    this.getTimeLeft();

    // Make countdown only if less than one day
    if (this.days === 0) {
      // Update the count down every 1 second
      this.counter = setInterval(() => {

        this.getTimeLeft();

        // Output the result
        this.countdownElement.innerHTML = this.daysHours + ' : ' + this.minutes + ' : <span>' + this.seconds +'</span>';

        // If the count down is over, write some text
        if (this.distance < 0) {
          clearInterval(this.counter);
          this.countdownElement.innerHTML = countDownEndedString;
        }
      }, 1000);
    }
  }

  getTimeLeft() {
    // Get todays date and time
    const now = new Date().getTime();

    // Find the distance between now an the count down date
    this.distance = this.countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    this.days = Math.floor(this.distance / (1000 * 60 * 60 * 24));
    this.hours = Math.floor((this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    this.daysHours = this.hours + (this.days * 24); // Days are not being shown, add to hours

    this.minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60));
    this.seconds = Math.floor((this.distance % (1000 * 60)) / 1000);

    if (this.hours.toString().length === 1) {
      this.hours = '0' + this.hours;
    }
    if (this.seconds.toString().length === 1) {
      this.seconds = '0' + this.seconds;
    }
    if (this.minutes.toString().length === 1) {
      this.minutes = '0' + this.minutes;
    }

    return {
      days: this.days,
      daysHours: this.daysHours,
      hours: this.hours,
      minutes: this.minutes,
      seconds: this.seconds
    };
  }
}

export { Countdown };
